import { useTranslation } from 'react-i18next';
import type { IChecklistItem } from '@interfaces/IScheduler';
import { requiresEvidence } from '@d-orca/shared/checklist';
import { ReviewRow } from './ReviewRow';

/**
 * The checklist as a row of the promise (task-checklist design, decision 4):
 * how many checks the commit agrees to, and how many of them need evidence.
 * Never a gap — a task may be promised without a checklist — so an empty one
 * is a fact (·), a filled one a tick (✓). The commit review and the drawer's
 * promise block show the same row.
 */
export function ChecklistReviewRow({ checklist }: { checklist: readonly IChecklistItem[] | undefined }) {
  const { t } = useTranslation();
  const checks = (checklist ?? []).filter((item) => item.kind === 'check');
  const evidence = checks.filter(requiresEvidence).length;
  return (
    <ReviewRow state={checks.length > 0 ? 'ok' : 'info'} label={t('scheduler.commit.row.checklist')}>
      <span data-testid="review-checklist">
        {checks.length === 0
          ? t('scheduler.commit.checklist.none')
          : evidence > 0
            ? t('scheduler.commit.checklist.withEvidence', { count: checks.length, evidence })
            : t('scheduler.commit.checklist.checks', { count: checks.length })}
      </span>
    </ReviewRow>
  );
}
